import React, { useEffect, useMemo, useState } from 'react'
import { Stack } from '@mui/material'
import { MobileExpandableDetailCard, MobileSearchFilterCard } from '../../../components/mobile'
import ReportTabMobileKpiSection from './ReportTabMobileKpiSection'
import KpiCardsSection from '../components/KpiCardsSection'
import {
  EFFECTIVENESS_MOBILE_USER_EXPANDABLE_CARD_FONT_SIZE,
  REPORT_EFFECTIVENESS_MOBILE_CODE_ACCENT,
  REPORT_MOBILE_KPI_ACCENT
} from './reportMobileKpiShared'
import EffectivenessReportEmptyState from '../components/EffectivenessReportEmptyState'
import EffectivenessSettlementMobileFilters from './EffectivenessSettlementMobileFilters'

export const REPORT_USER_LIST_MOBILE_ACCENT = REPORT_MOBILE_KPI_ACCENT

function normalizeKpi(kpiData) {
  if (!kpiData) return {}
  if (Array.isArray(kpiData)) return kpiData[0] || {}
  return kpiData
}

export default function ReportStandardUserListMobileTab({
  activeTab,
  selectedTab,
  kpiData,
  data,
  onSearchQuery,
  searchQuery,
  onRowClick,
  buildCardSections,
  userExpandableCardFontSize,
  showSummaryTabKpis = false,
  isSingleDayRange = true,
  showSettlementFilter = false,
  pendingSettlementFilter = null,
  onPendingSettlementFilterChange = null,
  isSettlementFilterDisabled = false
}) {
  const fs = userExpandableCardFontSize ?? EFFECTIVENESS_MOBILE_USER_EXPANDABLE_CARD_FONT_SIZE
  const kpiFlat = useMemo(() => normalizeKpi(kpiData), [kpiData])
  const [filterInput, setFilterInput] = useState(searchQuery || '')
  const [expandedUserUid, setExpandedUserUid] = useState(null)

  const toggleUserCardExpand = (userUid) => {
    setExpandedUserUid((prev) => (prev === userUid ? null : userUid))
  }

  useEffect(() => {
    setFilterInput(searchQuery || '')
  }, [searchQuery])

  const handleClearSearch = () => {
    setFilterInput('')
    onSearchQuery('')
  }

  const handleSearchSubmit = () => {
    onSearchQuery(String(filterInput || '').toLowerCase())
  }

  return (
    <Stack spacing={2} sx={{ width: '100%', minWidth: 0 }}>
      {showSummaryTabKpis ? (
        <KpiCardsSection
          kpiData={kpiFlat}
          selectedTab={selectedTab}
          collapsibleSections
          compactValues
          isSingleDayRange={isSingleDayRange}
        />
      ) : (
        <ReportTabMobileKpiSection
          selectedTab={selectedTab}
          kpiFlat={kpiFlat}
          isSingleDayRange={isSingleDayRange}
        />
      )}

      {showSettlementFilter ? (
        <EffectivenessSettlementMobileFilters
          searchInput={filterInput}
          onSearchInputChange={setFilterInput}
          onSearchSubmit={handleSearchSubmit}
          onClearSearch={handleClearSearch}
          pendingSettlementFilter={pendingSettlementFilter}
          onPendingSettlementFilterChange={onPendingSettlementFilterChange}
          isSettlementFilterDisabled={isSettlementFilterDisabled}
          isSingleDayRange={isSingleDayRange}
        />
      ) : (
        <MobileSearchFilterCard
          value={filterInput}
          onChange={setFilterInput}
          onSubmit={handleSearchSubmit}
          onClear={handleClearSearch}
        />
      )}

      <Stack spacing={1.5}>
        {data.length === 0 ? (
          <EffectivenessReportEmptyState tabValue={activeTab} />
        ) : (
          data.map((model, index) => {
            const uid = model.user_uid || `idx-${index}`
            const { summaryRows, detailRows } = buildCardSections(model, { isSingleDayRange })
            return (
              <MobileExpandableDetailCard
                key={uid}
                code={model.user_uid}
                bodyFontSize={fs}
                codeFontSize={fs}
                summaryLabelFontSize={fs}
                summaryValueFontSize={fs}
                detailLabelFontSize={fs}
                detailValueFontSize={fs}
                onCodeClick={(e) => onRowClick(e, model.user_uid)}
                expanded={expandedUserUid === uid}
                onToggleExpand={() => toggleUserCardExpand(uid)}
                summaryRows={summaryRows}
                detailRows={detailRows}
                accentColor={REPORT_USER_LIST_MOBILE_ACCENT}
                codeAccentColor={REPORT_EFFECTIVENESS_MOBILE_CODE_ACCENT}
                lighterDetailDividers
                expandAriaLabel={
                  expandedUserUid === uid
                    ? `Ocultar detalle de ${model.user_name || model.user_uid}`
                    : `Mostrar detalle de ${model.user_name || model.user_uid}`
                }
                detailRegionAriaLabel={`Detalle del usuario ${model.user_uid}`}
              />
            )
          })
        )}
      </Stack>
    </Stack>
  )
}
